import { environment as ENV } from './../../../environments/environment';
import { LocalStorageService } from './../../shared/services/loca-storage.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
@Injectable()
export class AuthPaymentGuardService implements CanActivate {

  constructor(
    private _storageService: LocalStorageService,
    private _router: Router
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const authPayment: any = await this._storageService.get(ENV.environment.KEYS.PAYMENT_AUTH);

    if (!authPayment) {
      this._router.navigate(['/payment/auth-payment']);
    }
    return !!authPayment;
  }



}



// WEBPACK FOOTER //
// ./src/app/core/guards/auth-payment-guard.service.ts